import React from 'react';
import { Typography, Button, Form, Input, Checkbox, message } from 'antd';
import './common.css'; // Import the common CSS file
import './Borrow.css'; // Import the CSS file
import { useNavigate } from 'react-router-dom';
const { Title } = Typography;

const Register = () => {
    const navigate = useNavigate();
    
    const [form] = Form.useForm();

    const onFinish = async (values) => {
        
        console.log(values);
        try {
            //const response = await fetch(`http://localhost:8000/register`, {
            const response = await fetch(`https://54.178.141.189/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: values.email,
                    name: values.name,
                    password: values.password,
                    phone: values.phone 
                })
            });
            const data = await response.text();
            if (data === 'Registration successful') {
                message.success("Registration successful, please log in");
                setTimeout(() => {
                    navigate('/login'); // Redirect to login page after successful registration
                }, 1500); // Delay
            } else if (data === 'Need confirmation') {
                message.error("Already registered, please check your inbox");
            } else if (data === 'User already exists') {
                message.error("User already exists");
            } else {
                message.error("Registration failed"); 
            }
            form.resetFields();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <div className="borrow-container">
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100vh' }}>
        <div className="content-container-app">
            <Title level={1} style={{ fontFamily: 'Normal', fontSize: '2.5rem', fontWeight: 'bold', textAlign: 'center' , marginBottom:"0rem"}}>臺大循環餐盒系統試辦計畫</Title>
            <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginBottom:"0rem", marginBottom:"0rem"}}>NTU ECOntainer Pilot Program</p>
                <img src="/eco-packaging.png" alt="Logo" style={{ width: '25%'}} />
                <Title level={2} style={{ fontFamily: 'Monospaced', fontSize: '2em', marginBottom:"0rem" }}>使用者註冊</Title>
                <p style={{ fontFamily: 'Monospaced', fontSize: '2em', marginBottom:"0rem" }}>User Registration</p>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '-5%' }}>
                    <Form
                        form={form}
                        name="register"
                        onFinish={onFinish}
                        initialValues={{
                            prefix: '86',
                        }}
                        style={{
                            maxWidth: 250,
                        }}
                        scrollToFirstError
                    >

                        <Form.Item
                            name="name"
                            label="Name"
                            rules={[
                                {
                                    required: true,
                                    message: '名字記得填喔! Please input your name!',
                                },
                            ]}
                        >
                            <Input size="small" />
                        </Form.Item>
                        <Form.Item
                            name="email"
                            label="Email"
                            rules={[
                                {
                                    type: 'email',
                                    message: 'Email 格式錯誤! Please input a valid email!',
                                },
                                {
                                    required: true,
                                    message: 'Email 記得填喔!  Please input your email!',
                                },
                                () => ({
                                    validator(_, value) {
                                        if (!value || /@ntu\.edu\.tw$/.test(value)) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('請用NTU Mail註冊! Please use NTU Mail!'));
                                    },
                                }),
                            ]}
                        >
                            <Input size="small" />
                        </Form.Item>

                        <Form.Item
                            name="phone"
                            label="Cellphone"
                            rules={[
                                {
                                    required: true,
                                    message: '請輸入手機號碼! Please input your phone number!',
                                },
                                {
                                    pattern: /^09\d{8}$/,
                                    message: '請輸入有效的手機號碼! Please input a valid phone number!',
                                },
                            ]}
                        >
                            <Input size="small" />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            label="Password"
                            rules={[
                                {
                                    required: true,
                                    message: '請輸入密碼! Please input your password!',
                                },
                            ]}
                            hasFeedback
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            name="agreement"
                            valuePropName="checked"
                            rules={[
                                {
                                    validator: (_, value) =>
                                        value ? Promise.resolve() : Promise.reject(new Error('使用此系統前請先閱讀並同意使用者協議 Please read and agree to the user agreement before using this system')),
                                },
                            ]}
                        >
                            <Checkbox>
                                同意 <a href='https://everlasting-station-cfe.notion.site/84a44b664612428c8b75e77a04f104e7?pvs=4'>使用者協議</a>
                                <br/>
                                Agree to <a href="https://everlasting-station-cfe.notion.site/84a44b664612428c8b75e77a04f104e7?pvs=4" target="_blank" rel="noopener noreferrer">terms of service</a>
                            </Checkbox>
                        </Form.Item>

                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button type="primary" htmlType="submit">Submit</Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
        </div>
    );
};

export default Register;